// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"letters-w"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5 5L5 18C5 18.5523 5.44772 19 6 19H12M12 19L12 5M12 19H18C18.5523 19 19 18.5523 19 18V5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-letters-w')
export default class LettersWIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'letters-w',
    }
  }
}
